var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTimeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74 74"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Time Icon - Green"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 32922"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 32921"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 25865",
    fill: "none",
    d: "M0 0h74v74H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 32923",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 840",
    d: "M69.002 37.396a32.056 32.056 0 01-32.1 31.6A32.058 32.058 0 015.021 35.918 32.033 32.033 0 0137.137 5.002a32.028 32.028 0 0131.865 32.394zM37.425 65.775A28.827 28.827 0 0065.762 35.54 28.819 28.819 0 0035.53 8.247a28.77 28.77 0 00-27.29 29.93 28.776 28.776 0 0029.185 27.598z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 841",
    d: "M38.613 35.393h20.44a1.7 1.7 0 011.669.893 1.6 1.6 0 01-1.2 2.3 3.954 3.954 0 01-.463.024H37.24a1.639 1.639 0 01-1.794-1.278 2.06 2.06 0 01-.041-.46V14.838a1.61 1.61 0 012.69-1.3 1.482 1.482 0 01.509 1.058c.01.144.011.288.011.433v19.93z"
  })))));
}

export default __webpack_public_path__ + "be743e509af248e5830edb1851f4c460.svg";
export { SvgTimeIcon as ReactComponent };